import { useContext } from 'react'
import { ThemeContext } from 'contexts/theme/ThemeContext'

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used inside a ThemeProvider')
  }
  return context
}

export default useTheme
